import ApiBase from '../ApiBase';

class PushNotification extends ApiBase {
    route = '/push-notifications';
};

export default new PushNotification();